module.exports = __webpack_public_path__ + "static/vft-placeholder-video-cbc7a13a1e1731ac60e68138eca5dd15.png";